const data = {
  company: 'Allstate',
  insuranceUrl: 'https://www.allstate.com/auto-insurance.aspx'
};

export default data;
